import { BlockType } from "@pathwright/blocks-engine"
import { BLOCK_HASH_PREFIX } from "./constants"

// --- Link URL ---

/**
 * Build the full URL for a block link (current page URL without hash + block hash).
 * Use this when copying a link to a block.
 */
export function getBlockLinkUrl(blockId: string, baseUrl?: string): string {
  const url =
    baseUrl ?? (typeof window !== "undefined" ? window.location.href : "")
  const withoutHash = url.includes("#")
    ? url.substring(0, url.indexOf("#"))
    : url
  return `${withoutHash}#${BLOCK_HASH_PREFIX}${blockId}`
}

// --- Hash resolution (legacy + canonical block ids) ---

/**
 * Resolve a hash id (e.g. from URL #block-xyz) to the canonical DOM element id.
 * Supports legacy block links: if the id is a migrated_from_firebase_id we map
 * to the block's current id so scroll targets the element with id="block-{block.id}".
 */
export function resolveBlockHashToElementId(
  hashId: string,
  blocks: BlockType[]
): string {
  if (!hashId.startsWith(BLOCK_HASH_PREFIX)) return hashId
  const targetId = hashId.slice(BLOCK_HASH_PREFIX.length)
  const block = blocks.find(
    (b) => b.id === targetId || b.migratedFromFirebaseId === targetId
  )

  return `${BLOCK_HASH_PREFIX}${block?.id}`
}
